import React from 'react'
import { ButtonLight } from '../../../../components'
import { notification } from '../../../../components/common/notifications/Notifications'
import { t, Trans } from '@lingui/macro'
import { formatDateShort } from '../../../../utils/dateHelpers'
import { CellInfo } from 'react-table'
import { ManageSurveyContext } from '../ManageSurveyContext'
import { useResendMutation } from './surveysOperations.codegen'

type ResendSurveyButtonProps = {
  row: CellInfo
}

export const ResendSurveyButton: React.FC<ResendSurveyButtonProps> = ({
  row
}) => {
  const { survey } = React.useContext(ManageSurveyContext)

  const [resendSurvey] = useResendMutation()
  if (
    !(
      row.original.started_at ||
      row.original.completed_at ||
      survey.completed_at
    )
  ) {
    return (
      <ButtonLight
        onClickAsync={async () => {
          const { data } = await resendSurvey({
            variables: {
              surveyId: survey.id,
              userId: row.original.user.id
            }
          })
          if (data && data.admin.survey.resend) {
            notification.info(
              t`Successfully resent to ${row.original.user.userIdentity}`
            )
          } else {
            notification.error(t`Error during resend action`)
          }
        }}
      >
        <Trans>Resend</Trans>
      </ButtonLight>
    )
  } else {
    return <>{formatDateShort(row.original.started_at)}</>
  }
}
